import { render, staticRenderFns } from "./Mcq.vue?vue&type=template&id=35c99747"
import script from "./Mcq.vue?vue&type=script&lang=js"
export * from "./Mcq.vue?vue&type=script&lang=js"
import style0 from "./Mcq.vue?vue&type=style&index=0&id=35c99747&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports